export class FindAllGroups {
  public static readonly type = '[Organisation/Group/List] FindAllGroups';
}
